<template>
  <q-dialog v-model="visible">
    <q-card class="full-card">
      <q-toolbar class="auto-height horizontal-line">
        <q-toolbar-title class="q-pa-sm"> Flex Message JSON </q-toolbar-title>
        <q-btn flat round dense icon="close" @click="onCancel" />
      </q-toolbar>
      <q-card-section>
        <!-- :readonly="!isAdmin" -->
        <div class="q-pa-md"><q-input v-model="jsonString" type="textarea" rows="30" /></div>
        <div class="row no-wrap items-center q-my-md q-pr-md">
          <q-space />
          <div class="q-gutter-sm">
            <q-btn no-caps flat class="btn-cancel" @click="onCancel">{{ $t('cancel') }} </q-btn>
            <q-btn no-caps class="btn-save" @click="onSubmit"> {{ $t('save') }} </q-btn>
          </div>
        </div>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script lang="ts">
import { mixins, Options } from 'vue-class-component'
import BaseFormDialogMixin from '@/components/common/mixins/BaseFormDialogMixin.vue'
import { maska } from 'maska'
import { Prop, Watch } from 'vue-property-decorator'
import { IFlexMessageBubble, IFlexMessageCarousel } from '@/utils/types'

@Options({
  components: {},
  directives: { maska },
  emits: ['update:modelValue', 'submitJson'],
})
export default class FlexMessageJSONModal extends mixins(BaseFormDialogMixin) {
  @Prop()
  modelValue!: IFlexMessageBubble | IFlexMessageCarousel

  @Prop()
  isAdmin!: boolean

  jsonString = ''

  get value() {
    return this.modelValue
  }

  set value(value: IFlexMessageBubble | IFlexMessageCarousel) {
    this.$emit('update:modelValue', value)
  }

  onSubmit() {
    this.value = JSON.parse(this.jsonString)
    this.$emit('submitJson', JSON.parse(this.jsonString))
    this.visible = false
  }

  @Watch('modelValue', { deep: true })
  syncJsonString() {
    this.jsonString = JSON.stringify(this.modelValue, null, 2)
  }

  created() {
    this.syncJsonString()
  }
}
</script>

<style scoped lang="scss">
</style>
